import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import { package as packagePropType } from 'lib/CustomPropTypes';

import Background from 'components/Background';
import PackageHeader from 'components/PackageHeader';
import Navigation from 'components/packages/HeaderPackage/Navigation';
import Wrapper from 'components/packages/HeaderPackage/Wrapper';

import SpacingContainer from './SpacingContainer';

const mapStateToProps = ({ front: { curation, stackCommerceFront } }) => ({
  seoTitle: curation.seoTitle,
  stackCommerceFront,
});

function CollectionLead(props) {
  const {
    content = {},
    pkgClassName,
    stackCommerceFront,
    seoTitle,
    dekRenderer,
    postContentRenderer,
  } = props;

  const { metadata = {}, id, packageIndex } = content || {};

  const {
    title,
    description,
    updatesButtonUrl,
    updatesButtonText,
    logoUrl,
  } = metadata || {};

  const altDescription = title || seoTitle;
  const hasLogo = logoUrl && logoUrl.length;
  const imageUrl = metadata.imageUrl || metadata.backgroundImageUrl;

  return (
    <Wrapper
      id={id}
      className={classNames(
        pkgClassName,
        'collection-lead',
        {
          stackCommerceFront,
        },
      )}
      packageIndex={packageIndex}
    >
      <Background
        imageUrl={imageUrl}
        useBackground
        animate
        styleOverride={{
          bgColor: classNames({ 'bg-white': stackCommerceFront }),
        }}
      >
        <SpacingContainer>
          <div className="layout-grid-container w-100 tc">
            <div className="layout-grid-item grid-col-10-l grid-col-push-1-l ph6 ph0-l">
              {(!hasLogo && title) && (
                <PackageHeader
                  className={classNames(
                    'collection-lead__text-header',
                    {
                      'gray-100': stackCommerceFront,
                      white: !stackCommerceFront,
                    },
                  )}
                  packageIndex={packageIndex}
                  data-test="collection-lead__package-header"
                >
                  {title}
                </PackageHeader>
              )}
              {hasLogo && (
                <PackageHeader
                  className={classNames('ma0 df justify-center dib-l collection-lead__logo-wrapper')}
                  packageIndex={packageIndex}
                >
                  <img
                    className={classNames('h-auto w-auto db z-1 collectionLead-border__logo')}
                    src={logoUrl}
                    alt={altDescription}
                  />
                </PackageHeader>
              )}

              {typeof dekRenderer === 'function' && dekRenderer()}
              {!dekRenderer && description && (
                <p
                  className={classNames(
                    'font-body f3 f4-m lh-copy mb0 mt1 mt2-m mt4-l',
                    {
                      'gray-100': stackCommerceFront,
                      white: !stackCommerceFront,
                    },
                  )}
                >
                  {description}
                </p>
              )}

              <Navigation
                {...metadata}
                styleOverride={{
                  linkListWrapper: 'white f4 f6-m f7-l mt5 mt7-m mt8-l collection-lead__link-list-wrapper',
                  linkList: 'collection-lead__link-list',
                  linkListItem: 'collection-lead__link-list-item',
                }}
              />

              {updatesButtonUrl && (
                <a href={updatesButtonUrl}>
                  <button
                    type="button"
                    className={classNames('ttu mt5 mt8-m mt7-l collection-lead__updates-button')}
                    data-test="collection-lead__updates-button"
                  >
                    {updatesButtonText || i18next.t('Sign Up For Updates')}
                  </button>
                </a>
              )}

              {typeof postContentRenderer === 'function' && postContentRenderer()}
            </div>
          </div>
        </SpacingContainer>
      </Background>
    </Wrapper>
  );
}

CollectionLead.propTypes = {
  content: packagePropType.isRequired,
  dekRenderer: PropTypes.func,
  pkgClassName: PropTypes.string,
  postContentRenderer: PropTypes.func,
  stackCommerceFront: PropTypes.bool,
  seoTitle: PropTypes.string,
};

CollectionLead.contextTypes = {
  vertical: PropTypes.string,
};

CollectionLead.defaultProps = {
  dekRenderer: null,
  pkgClassName: 'pkg lead collectionLead',
  postContentRenderer: null,
  seoTitle: '',
  stackCommerceFront: false,
};

export default connect(mapStateToProps)(CollectionLead);
